import { useState } from 'react'
import { Button } from './ui'

/**
 * One-time enroll-token reveal, shared by gateway create (Gateways) and
 * re-enroll (GatewayDetail): the token is plaintext EXACTLY ONCE, here only.
 *
 * This is the final step of the EnrollWizard — the wizard's artifact
 * choice, download and ready gate all happen before this renders.
 */
export function EnrollTokenReveal({ token, onDone }: { token: string; onDone: () => void }) {
  const [copied, setCopied] = useState(false)

  async function copyToken() {
    try {
      await navigator.clipboard.writeText(token)
      setCopied(true)
    } catch {
      /* clipboard unavailable (permissions) — the token stays selectable */
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <p className="rounded-sm border border-ostrel-warn/50 bg-ostrel-warn/10 px-3 py-2 text-xs text-ostrel-warn">
        This enroll token is shown only now — it is never retrievable again. Copy it before closing
        this dialog.
      </p>
      <div className="flex items-center gap-2">
        <code className="tnum min-w-0 flex-1 break-all rounded-sm border border-ostrel-line bg-ostrel-sand px-3 py-2 font-mono text-xs text-ostrel-ink">
          {token}
        </code>
        <Button variant="navy" size="sm" onClick={copyToken}>
          {copied ? 'Copied' : 'Copy'}
        </Button>
      </div>
      <div className="flex justify-end">
        <Button variant="navy" size="sm" onClick={onDone}>
          Done
        </Button>
      </div>
    </div>
  )
}
